import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=600b5b90"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports